import { createFileRoute } from "@tanstack/react-router";
import { AdvertisingDashboardRoute } from "../../../../../../views/advertising/AdvertisingDashboardRoute";

export const Route = createFileRoute("/_authenticated/user/advertising/dashboard/category/$id")({
  component: AdvertisingDashboardRoute,
  staticData: { application: "Advertising" },
});
